<template>
  <div
    class="login-page"
    ref="appRef"
    v-loading="loading"
    element-loading-text="System Loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(42, 43, 44, 0.6)"
    id="loginPage"
  >
    <div class="logoImage">
      <img v-show="!loading" :src="sysConfig.loginLogo ? baseUrl + sysConfig.loginLogo : '/static/img/loginLogo.png'" alt="" srcset="" />
    </div>
    <div class="lang-swtich">
      <el-tooltip v-if="showreboot" class="item" effect="dark" :content="$t('login.reboot')" placement="top-start">
        <span @click="handleReload" class="iconfont icon-shuaxin" style="margin-right: 20px; font-size: 76px"></span>
      </el-tooltip>
      <el-dropdown trigger="click" @command="handleSetLanguage">
        <span class="iconfont icon-zhongyingwenqiehuan-xianshizhongyingwen2"></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :disabled="language === 'zh'" command="zh">中文 </el-dropdown-item>
          <el-dropdown-item :disabled="language === 'en'" command="en">English </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="footer-logo">Powered by LnXall @ 2021</div>
    <form class="login-content">
      <div class="content">
        <div class="titlebox">
          <div class="band-contnet">
            <!-- <div><img src="/static/img/band.png" alt="" srcset="" /></div> -->
            <div class="title">{{ sysConfig.systemTitle ? sysConfig.systemTitle : $t("login.title") }}</div>
          </div>
        </div>
        <div class="form-content">
          <div class="form-container">
            <div class="form-item">
              <span class="form-icon iconfont icon-yonghu"></span>
              <input type="text" :placeholder="$t('login.usernamePlaceholder')" v-model="loginForm.username" />
            </div>
            <div class="form-item">
              <span class="form-icon iconfont icon-mima1"></span>
              <input :type="passwordType" :placeholder="$t('login.passwordPlaceholder')" v-model="loginForm.password" current-password />
              <span class="form-show-mima iconfont icon-yincangmima" @click="showPassword"></span>
            </div>
          </div>
        </div>
        <div class="form-buttom">
          <div class="login-btn" @click="handleLogin">{{ $t("login.submit") }}</div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { loginByUsername, getSysConfig, getVersions, getSubsystems } from "@/api/spms";
import { setStore, getStore } from "@/utils/store";
import md5 from "md5";
import { mapGetters } from "vuex";
import i18n from "@/lang";
import drawMixin from "@/utils/drawMixin";

export default {
  name: "Login",
  mixins: [drawMixin],
  data() {
    return {
      loading: false,
      loginForm: {
        //租户ID
        tenantId: "000000",
        //用户名
        username: "",
        //密码
        password: "",
      },
      passwordType: "password",
      sysConfig: {},
      baseUrl: imgBaseUrl,
      // baseUrl: "http://192.168.22.207/" ,
      timer: null,
      showreboot: false,
    };
  },
  computed: {
    ...mapGetters(["language"]),
  },
  inject: ["mqttMSG"],
  created() {
    // 动态控制全屏按钮
    // mode 1 无
    let mode = this.$route.query.mode;
    if (mode) {
      setStore({
        name: "web_type",
        content: mode,
      });
    }
    this.showreboot = mode || getStore({ name: "web_type" });
  },
  mounted() {
    let self = this;
    document.getElementById("loginPage").onkeydown = function (event) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13) {
        self.handleLogin();
      }
    };

    let tenantId = this.$route.query.tenantId;
    let username = this.$route.query.username;
    let password = this.$route.query.password;
    if (tenantId && username && password) {
      this.loginForm = { tenantId, username, password };
      this.handleLogin();
    }
    this.saveSysConfig();
  },
  methods: {
    showPassword() {
      this.passwordType === "" ? (this.passwordType = "password") : (this.passwordType = "");
    },
    handleReload() {
      const link = document.createElement("a");
      link.href = "wems-protocol://onreload";
      link.click();
    },
    handleLogin() {
      var self = this;
      this.loading = true;
      let reqdata = Object.assign({}, JSON.parse(JSON.stringify(this.loginForm)), { password: md5(this.loginForm.password) });
      if (!this.loginForm.username) {
        this.$message({
          message: i18n.t("login.usernameRequired"),
          type: "warning",
        });
        this.loading = false;
        return;
      }
      if (!this.loginForm.password) {
        this.$message({
          message: i18n.t("login.passwordRequired"),
          type: "warning",
        });
        this.loading = false;
        return;
      }
      loginByUsername(reqdata)
        .then((response) => {
          self.loading = false;
          if (response.data.error_code == 400) {
            self.$message.error(response.data.error_description);
          } else {
            setStore({
              name: "web_tenantId",
              content: response.data.tenant_id,
              type: "session",
            });
            setStore({
              name: "access_token",
              content: response.data.access_token,
              type: "session",
            });
            setStore({
              name: "refresh_token",
              content: response.data.refresh_token,
              type: "session",
            });
            setStore({
              name: "userInfo",
              content: response.data,
              type: "session",
            });
            this.getVersion();
            this.getSubSys();
            if (response.data.mainPage == 2) {
              self.$router.push({
                path: "/guestPage",
              });
            } else {
              self.$router.push({
                path: "/index",
              });
            }
          }
        })
        .catch(function (err) {
          self.loading = false;
        });
    },
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.commit("SET_LANGUAGE", lang);
    },
    saveSysConfig() {
      this.loading = true;
      this.doGetConfig();
      this.timer = setInterval(() => {
        if (this.sysConfig.systemTitle === undefined || this.sysConfig.loginLogo === undefined) {
          this.doGetConfig();
        }
      }, 5000);
    },
    doGetConfig() {
      getSysConfig()
        .then((res) => {
          if (res && res.data && res.data.data) {
            if (this.timer) clearInterval(this.timer);
            this.loading = false;
            this.sysConfig = res.data.data;
            setStore({
              name: "systemSet",
              content: res.data.data,
              type: "session",
            });
            this.$store.commit("SET_SYSTEMSET", res.data.data);
            window.console.log("login___________________________________");
            try {
              this.mqttMSG();
            } catch (e) {
              console.log("初始化MQTT配置失败！——————————————————————————————————————");
            }
          } else {
            console.log("接口访问失败——————————————————", res);
          }
        })
        .catch((err) => {
          console.log("服务访问失败——————————————————", err);
        });
    },
    getVersion() {
      getVersions().then((res) => {
        setStore({
          name: "version",
          content: res.data.data,
          type: "session",
        });
      });
    },
    // 获取类型
    getSubSys() {
      getSubsystems({ current: 1, size: 1000 }).then((res) => {
        let list = res.data.data.records || [];
        let subsSYS = list.filter((item) => {
          return item.isVisible === 1;
        });
        this.$store.commit("SET_SUBSYSTEM", subsSYS);
      });
    },
  },
  destroyed() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.el-dropdown {
  color: var(--fontcolor) !important;
}

.login-page {
  // width: 1920px;
  // height: 1080px;
  // overflow: scroll;
  box-sizing: border-box;
  width: 1920px;
  height: 1080px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: left top;
  overflow: hidden;
  /*overflow: hidden;*/
  background-image: var(--login_bg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  // position: relative;

  .logoImage {
    position: absolute;
    top: 64px;
    left: 76px;
    width: 450px;
    max-height: 180px;

    img {
      width: 100%;
      max-height: 180px;
    }
  }

  .lang-swtich {
    position: absolute;
    top: 64px;
    right: 76px;
    color: var(--fontcolor);
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;

    .iconfont {
      font-size: 64px;
      cursor: pointer;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  }

  .footer-logo {
    position: absolute;
    bottom: 45px;
    right: 64px;
    color: var(--footerLg);
    font-size: 18px;
  }

  .login-content {
    border: var(--login_border);
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    width: 880px;
    height: 578px;

    .content {
      width: 100%;
      height: 100%;
      background-color: var(--login_box_bg);
      box-shadow: 2px 2px 12px #353e46bd;

      .titlebox {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 64px 0 100px 0;

        .band-contnet {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          width: 600px;

          .title {
            color: var(--fontcolor);
            font-size: 40px;
            text-align: center;
            letter-spacing: 6px;
            font-family: "Microsoft Yahei";
          }
        }
      }

      .form-content {
        display: flex;
        justify-content: center;
        align-items: center;

        .form-container {
          width: 600px;

          .form-item {
            box-sizing: border-box;
            position: relative;
            border-bottom: 2px solid var(--fontcolor);
            margin-bottom: 24px;

            .form-icon {
              color: var(--fontcolor);
              position: absolute;
              font-size: 40px;
              padding-top: 8px;
            }

            .form-show-mima {
              position: absolute;
              color: var(--fontcolor);
              font-size: 28px;
              top: 20px;
              right: 10px;
              cursor: pointer;
              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            }

            input {
              background-color: transparent;
              border: none;
              outline: none;
              color: var(--input_font);
              font-size: 32px;
              width: 600px;
              height: 60px;
              line-height: 60px;
              box-sizing: border-box;
              padding: 0 60px 0 90px;
            }
          }
        }
      }

      .form-buttom {
        left: 0;
        right: 0;
        bottom: 64px;
        position: absolute;
        display: flex;
        padding: 0 120px;

        .login-btn {
          background-color: var(--fontcolor);
          width: 442px;
          height: 62px;
          line-height: 62px;
          font-size: 32px;
          color: var(--login_btn);
          text-align: center;
          border-radius: 10px;
          margin: 0 auto;
          cursor: pointer;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        }

        .login-btn:hover {
          background-color: #6191e3;
        }
      }
    }
  }
}

::placeholder {
  color: #494949;
  font-size: 24px;
}

input:-webkit-autofill,
input:-webkit-autofill:focus {
  transition: background-color 600000s 0s, color 600000s 0s;
}
</style>
